define('TescoMobile_Customer/js/view/account/manage-one-off-data',['uiComponent', 'jquery', 'mage/translate'], function (Component, $) {
  'use strict';

  return Component.extend({
    initialize: function () {
      this._super();
      $('input[name="one_off_data"]').click(function () {
        $("#submit-one-off-data-update").attr("disabled", !this.checked);
      });
      $('#submit-one-off-data-update').click(function (event) {
        event.preventDefault();
      }.bind(this));
    }
  });
});

